import React from 'react'

const VehicleFitIcon = () => (
  <svg width="32" height="32" viewBox="0 0 30 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.5 14.3333L6.67551 16.9796C6.88518 17.1544 7.14946 17.25 7.42239 17.25H20.5775C20.8505 17.25 21.1148 17.1544 21.3244 16.9796L24.5 14.3333M7.58333 21.3334H7.595M20.4167 21.3334H20.4283M9.52076 10.25H18.4793C19.3166 10.25 20.0898 10.6987 20.5051 11.4257L23.8852 17.3407C24.288 18.0458 24.5 18.8438 24.5 19.656V26.5834C24.5 27.2277 23.9777 27.7501 23.3333 27.7501H22.1667C21.5223 27.7501 21 27.2277 21 26.5834V25.4167H7V26.5834C7 27.2277 6.47766 27.7501 5.83333 27.7501H4.66667C4.02234 27.7501 3.5 27.2277 3.5 26.5834V19.656C3.5 18.8438 3.71194 18.0458 4.11487 17.3407L7.49485 11.4257C7.91028 10.6987 8.68342 10.25 9.52076 10.25ZM8.16667 21.3334C8.16667 21.6555 7.9055 21.9167 7.58333 21.9167C7.26117 21.9167 7 21.6555 7 21.3334C7 21.0112 7.26117 20.75 7.58333 20.75C7.9055 20.75 8.16667 21.0112 8.16667 21.3334ZM21 21.3334C21 21.6555 20.7388 21.9167 20.4167 21.9167C20.0945 21.9167 19.8333 21.6555 19.8333 21.3334C19.8333 21.0112 20.0945 20.75 20.4167 20.75C20.7388 20.75 21 21.0112 21 21.3334Z"
      stroke="#3E3E47"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <rect x="12" width="18" height="18" rx="9" fill="#94B87C" />
    <path
      d="M18.8733 11.5969L16.0733 8.79694L15.14 9.73027L18.8733 13.4636L26.8733 5.46361L25.94 4.53027L18.8733 11.5969Z"
      fill="#3E3E47"
    />
  </svg>
)

export default VehicleFitIcon
